import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=0e47da93&scoped=true"
import script from "./MenuBox.vue?vue&type=script&lang=js"
export * from "./MenuBox.vue?vue&type=script&lang=js"
import style0 from "./MenuBox.vue?vue&type=style&index=0&id=0e47da93&prod&lang=scss&scoped=true"
import style1 from "./MenuBox.vue?vue&type=style&index=1&id=0e47da93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47da93",
  null
  
)

export default component.exports